import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function CreateNewEntityButtons({ saveCompanyData, goBack, disabled = false }) {
    return (
        <span className="create-new-entity__controls--buttons">
            <button type="button"
                    onClick={saveCompanyData}
                    className="button-primary-lg"
                    disabled={disabled}>
                <FormattedMessage id="General_CoreFunctionality_UIText_general.create" />
            </button>
            <button type="button"
                    onClick={goBack}
                    className="button-secondary-lg"
                    disabled={disabled}>
                <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />
            </button>
        </span>
    );
}


// WEBPACK FOOTER //
// ./src/scripts/pages/CreateNewEntity/components/CreateNewEntityButtons.jsx